<template>
    <v-navigation-drawer v-model="drawerOpen" app color="black">
        <v-list color="bal-red" dark class="py-1">
            <v-list-group v-model="showExpand">
                <template v-slot:activator>
                    <v-list-item class="pl-0">
                        <v-list-item-avatar style="background-color: white">
                            <v-icon style="font-size: 35px; margin-top: 5px" color="#f41823">fas fa-user-tie</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-title
                            ><strong>{{ user.first_name }}</strong></v-list-item-title
                        >
                    </v-list-item>
                </template>
                <v-list-item :to="{ path: '/user-settings' }" :class="{ black: $route.name === 'user-settings' }">
                    <v-list-item-icon style="width: 24px !important">
                        <v-icon>{{ "fas fa-user-edit" }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ "User settings" | t }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ path: '/logout' }">
                    <v-list-item-icon style="width: 24px !important">
                        <v-icon>{{ "fa fa-sign-out" }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ "Log out" | t }}</v-list-item-title>
                </v-list-item>
            </v-list-group>
        </v-list>

        <v-list dense color="black">
            <template v-for="item in allowedViews">
                <v-list-group
                    v-if="item.children"
                    :key="'group_' + item.title"
                    active-class="active-drawer-item"
                    :class="{ 'active-drawer-item': isGroupActive(item.children) }"
                >
                    <template v-slot:activator>
                        <v-list-item class="pl-0" dark link active-class="active-drawer-item">
                            <v-list-item-icon style="width: 24px !important" color="white">
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ item.title | t }}</v-list-item-title>
                        </v-list-item>
                    </template>
                    <v-list-item
                        v-for="subItem in item.children"
                        :key="'sub_' + subItem.title"
                        :to="{ path: subItem.route }"
                        dark
                        link
                        active-class="active-drawer-item"
                    >
                        <v-list-item-icon style="width: 24px !important" color="white">
                            <v-icon>{{ subItem.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ subItem.title | t }}</v-list-item-title>
                    </v-list-item>
                </v-list-group>

                <v-list-item link dark active-class="active-drawer-item" v-if="item.route" :to="{ path: item.route }">
                    <v-list-item-icon style="width: 24px !important">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.title | t }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item
                    link
                    dark
                    active-class="active-drawer-item"
                    v-if="item.url && item.is_active"
                    @click="redirectToCorrectUrl(item)"
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.title | t }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import Store from "../store";
import router from "../router";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "main-drawer",
    props: ["drawerOpen"],
    data() {
        return {
            showExpand: false,
            title: true,
            menuDrawerItems: [
                { title: "Products", icon: "fal fa-box-alt", route: "/products" },
                { title: "Sales Invoices", icon: "fal fa-file-invoice", route: "/sales-invoices" },
                { title: "Shops map", icon: "fal fa-map", route: "/shops" },
                { title: "Shops", icon: "fal fa-shopping-cart", route: "/shops-admin" },
                { title: "Exports", icon: "fas fa-scroll", route: "/export-sale-invoice" },
                { title: "Export clients", icon: "fal fa-user", route: "/export-clients" },
                { title: "Clients", icon: "fal fa-user", route: "/clients" },
                // { title: "Clients", icon: "fal fa-user", route: "/clients" },
                { title: "Users", icon: "fal fa-user", route: "/users" },
                { title: "Unmatched shops", icon: "fas fa-home", route: "/unmatched-shops" },
                { title: "Rules", icon: "fal fa-ruler", route: "/rules" },
                { title: "Tags", icon: "fal fa-tags", route: "/tags" },
                { title: "Work order", icon: "fal fa-toolbox", route: "/work-order/line-number-select" },
                { title: "Campaigns", icon: "fal fa-fire", route: "/campaign" },
                {
                    title: "Analysis",
                    icon: "timeline",
                    children: [
                        { title: "Sales", route: "/analysis-view" },
                        { title: "Production", route: "/production-analysis" },
                    ],
                },
                { title: "Price monitoring", icon: "timeline", route: "/ext-product-price" },
                { title: "Shipments", icon: "fa-truck", route: "/shipments" },
                //{ title: "Notification center", icon: "fas fa-bell", route: "/notification-center" }
            ],
            drawerItems: [],
        };
    },
    computed: {
        ...mapState(["user"]),
        ...mapState("ProductStore", ["exportMode"]),
        allowedViews() {
            const customLinks = (this.user?.custom_links || []).map((link) => ({
                ...link,
                icon: "fal fa-window-restore",
            }));

            if (this.user.role === "superadmin") {
                return [...this.menuDrawerItems, ...customLinks];
            }

            const allowedMenuItems = this.menuDrawerItems
                .map((item) => {
                    if (item.children) {
                        const allowedChildren = item.children.filter((child) => this.hasPermission(child.route));
                        return allowedChildren.length ? { ...item, children: allowedChildren } : null;
                    }
                    return this.hasPermission(item.route) ? item : null;
                })
                .filter(Boolean);

            return [...allowedMenuItems, ...customLinks];
        },
    },
    async mounted() {
        if (!this.user.id) await Store.dispatch("getUserData");

        document.addEventListener("mousedown", this.mousedownHandler);

        if (this.user.role === "superadmin") {
            await this.menuDrawerItems.push({
                title: "Logs",
                icon: "fas fa-pencil-alt",
                route: "/logs",
            });
        }
        this.setNav();
    },
    created() {
        this.unsubscribe = this.$store.subscribe((mutation, state) => {
            if (mutation.type === "setUserCustomLinksData") {
                this.setNav();
            }
        });
    },
    methods: {
        isGroupActive(children) {
            return children.some((subItem) => subItem.route === this.$route.path);
        },
        mousedownHandler(e) {
            if (e.target.classList.contains("v-overlay__scrim") && !this.exportMode) {
                this.$emit("close");
            }
        },
        redirectToCorrectUrl(item) {
            if (item.open_in === "new tab") window.open(item.url, "_blank");
            else {
                Store.commit("setIframeModalInfo", { prop: "url", value: item.url });
                Store.commit("setIframeModalInfo", { prop: "title", value: item.title });
                Store.commit("toggleIframeModal", true);
                router.push("/iframe");
            }
        },
        setNav() {
            this.drawerItems = [];
            this.menuDrawerItems.forEach((element) => this.drawerItems.push(element));
            if (this.user && this.user.custom_links && this.user.custom_links.length > 0) {
                this.user.custom_links.forEach((element) => {
                    let newLink = {
                        ...element,
                        icon: "fal fa-window-restore",
                    };
                    this.drawerItems.push(newLink);
                });
            }
        },
        formatRouteToPermissionKey(route) {
            let formattedRoute = route.replaceAll("-", "_").replace("/", "").replace(/s$/, "");

            if (formattedRoute === "shops") {
                formattedRoute = "shops_map";
            } else if (formattedRoute === "shops_admin") {
                formattedRoute = "shop";
            } else if (formattedRoute === "export_sale_invoice") {
                formattedRoute = "export";
            } else if (formattedRoute === "sales_invoice") {
                formattedRoute = "invoice";
            } else if (formattedRoute === "rule") {
                formattedRoute = "rules";
            } else if (formattedRoute === "work_order/line_number_select") {
                formattedRoute = "work_order";
            } else if (formattedRoute === "analysis_view") {
                formattedRoute = "analysis";
            } else if (formattedRoute === "production_analysi") {
                formattedRoute = "production_analysis";
            } else if (formattedRoute === "ext_product_price") {
                formattedRoute = "price_monitoring";
            } else if (formattedRoute === "tag") {
                formattedRoute = "tag";
            }

            return formattedRoute;
        },
        hasPermission(route) {
            const permissionKey = this.formatRouteToPermissionKey(route);
            const userPermissions = this.user.permissions;
            return userPermissions[permissionKey]?.includes(PermissionsConstants.LIST);
        },
    },
};
</script>

<style scoped>
.v-list-item--active {
    background-color: transparent;
    position: relative;
}

.active-drawer-item {
    color: #f41823 !important;
}

.theme--dark.v-list-item--active:before {
    opacity: 0;
}

.theme--dark.v-list-item--active:after {
    position: absolute;
    right: 0;
    height: 100%;
    width: 4px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: red;
    content: "";
    display: block;
}

.fa-chevron-down {
    font-weight: 400 !important;
}

.v-list-item__title {
    font-size: 16px !important;
    font-weight: 400 !important;
}

:deep(.fa-chevron-down),
:deep(.fa-chevron-up) {
    color: white !important;
}
</style>
